'use strict';
const angular = require('angular');
import {Ids as ACTION_IDS} from '../../components/constants/action.constants';

/**
 * @brief      Load Json from server-side for translation
 *
 * @param      $rootScope  The root scope
 * @param      $http       The http
 * @param      $q          The quarter
 *
 * @return     API
 */
export function customLoader($rootScope, $http, $q) {

    /**
     * @brief      Load method of this factory
     *
     * @return     promise for custom loader
     */
    function load() {
        
        var deferred = $q.defer();

        $http({
          'url': (<any>window).properties.service.uri + ACTION_IDS.GET_LANGUAGE_KEYS,
          'method': 'GET',
          'headers': {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          'withCredentials': true
        }).then(response => {
          let data = response.data.entity;
          deferred.resolve(data);
        });

        return deferred.promise
    }

  // Public API here
  return load;
}

export default angular.module('nodeApp.customLoader', [])
  .factory('customLoader', customLoader)
  .name;



// WEBPACK FOOTER //
// ./client/app/services/language.service.ts